import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import { PROXY_URL_LANGUAGE_VARIANTS } from 'academy-common-lib/utils/url';
import styled from 'academy-common-lib/utils/Styling';
import { appendHubsContent } from '../../../../utils/urls';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import usageTracker from '../../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const LanguageLinksList = styled(UIList).withConfig({
  displayName: "LanguageLinks__LanguageLinksList",
  componentId: "sc-1mjhjyv-0"
})(["font-size:16px;text-align:center;margin:32px auto;display:flex;flex-wrap:wrap;justify-content:center;& a{display:inline-block;padding:8px 16px;}"]);
const LanguageLinks = () => {
  const handleClick = languageName => {
    usageTracker.track('navInteraction', {
      action: 'footer-language-link-click',
      value: languageName
    });
  };
  return /*#__PURE__*/_jsx(LanguageLinksList, {
    className: "m-bottom-8",
    children: supportedPublicLanguages.map(lang => /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(UILink, {
        className: "footer-link",
        href: appendHubsContent(`https://${PROXY_URL_LANGUAGE_VARIANTS[lang]}/`, LanguageNames[lang]),
        lang: lang,
        onClick: () => handleClick(LanguageNames[lang]),
        use: "unstyled",
        children: LanguageNames[lang]
      })
    }, lang))
  });
};
export default LanguageLinks;